<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/20">
    <img class="w-28" src="~/assets/images/loading.gif" />
  </div>
</template>
